import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { HomeComponent } from './home/home.component';
import { StartupComponent } from './startup/startup.component';
import { AboutComponent } from './about/about.component';
import { BusinessComponent } from './business/business.component';
import { OverseasComponent } from './overseas/overseas.component';
import { DigitalComponent } from './digital/digital.component';
import { ContactComponent } from './contact/contact.component';
import { FooterComponent } from './footer/footer.component';
import { RefundComponent } from './refund/refund.component';
import { HashLocationStrategy, LocationStrategy  } from '@angular/common';

@NgModule({
  declarations: [
    AppComponent,
    HomeComponent,
    StartupComponent,
    AboutComponent,
    BusinessComponent,
    OverseasComponent,
    DigitalComponent,
    ContactComponent,
    FooterComponent,
    RefundComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule
  ],
  providers: [{provide : LocationStrategy , useClass: HashLocationStrategy}],
  bootstrap: [AppComponent]
})
export class AppModule { }
